<script>
	import {mapGetters} from 'vuex'
	import Login from '@/components/Login'
	import avatars from '@/js/avatars'

	export default {
		name: 'Profile',
		data() {
			return {
				step: 1,
				componentName: 'Profile',
				birthday: '',
				name: '',
				breasts: false,
				vagina: false,
				penis: false,
				testicals: false,
				avatars,
				avatar: '',
				search: '',
				category: '',
				selectAvatar: false,
				consents: [
					{
						value: false,
						text:
							'I recognise my partners can change their mind on what they will or will not do',
					},
					{
						value: false,
						text:
							'I will not pressure my partner into doing things they will not do.',
					},
					{
						value: false,
						text: `I will not judge my partner on what they want or don't want`,
					},
					{
						value: false,
						text: `We will create a 'safe word' to use where consent might not be clear (eg, fantasy play)`,
					},
				],
			}
		},
		components: {Login},
		props: [],
		computed: {
			results() {
				let results = this.search
					? avatars.filter(item => {
							return [
								...item.aliases,
								...item.tags,
								item.description,
								item.category,
							]
								.join(', ')
								.toLowerCase()
								.match(this.search)
					  })
					: avatars

				return this.category
					? results.filter(item => item.category === this.category)
					: results
			},
			categories() {
				return this.avatars.reduce((arr, item) => {
					if (!arr.includes(item.category)) {
						arr.push(item.category)
					}
					return arr
				}, [])
			},
			years() {
				return [...Array(1 + 2019 - 1900).keys()].map(v => 1900 + v).reverse()
			},
			months() {
				return [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December',
				]
			},
			days() {
				return Array.from(Array(31).keys()).map(day => day + 1)
			},
			...mapGetters([]),
		},
		methods: {
			randomAvatar() {
				this.selectAvatar = false
				this.avatar = avatars[Math.floor(Math.random() * avatars.length)].emoji
			},
		},
		mounted() {
			if (!this.avatar) {
				this.randomAvatar()
			}
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				// console.log('<Profile> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<div class="Profile">
		<!-- <v-select
			class="Profile"
			:items="avatars"
			label="Avatar"
			item-value="emoji"
			item-text="emoji"
			v-model="avatar"
			clearable
		></v-select> -->

		<!-- <select style="font-size: 72px;">
			<option
				v-for="avatar in avatars"
				:key="avatar.emoji"
				:value="avatar.emoji"
				>{{ avatar.emoji }}</option
			>
		</select>
		{{ avatars }} -->

		<v-stepper v-model="step" class="ma-5">
			<v-stepper-header>
				<v-stepper-step :complete="step > 1" step="1">Profile</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step :complete="step > 2" step="2">Account</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step :complete="step > 3" step="3">Consent</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step step="4">Your First ToDO</v-stepper-step>
			</v-stepper-header>
			<v-stepper-items>
				<v-stepper-content step="2">
					<v-card class="mb-1">
						<p>Important:</p>
						<p>
							An account is not needed HOWEVER, having an account will give you
							the option to track multple todos over time and more importantly,
							lets you remove a ToDo from your partner (eg: after a breakup).
						</p>
						<Login></Login>
					</v-card>
					<v-btn flat @click="step--">Back</v-btn>

					<v-btn color="primary" @click="step = 3">
						Continue without an account
					</v-btn>
				</v-stepper-content>

				<v-stepper-content step="1">
					<v-card class="mb-5">
						<p>
							Please provide a name. This will be used for all the ToDo's you
							have with your partners.
						</p>
						<v-text-field
							persistent-hint
							label="Please provide a name:"
							required
							v-model="name"
							autofocus
						></v-text-field>
						<p>
							We focus on the fun bits not on gender. Please check the boxes
							below for the "parts" you have.
						</p>
						<v-switch v-model="breasts" label="I have breasts"></v-switch>
						<v-switch v-model="vagina" label="I have a vagina"></v-switch>
						<v-switch v-model="penis" label="I have a penis"></v-switch>
						<v-switch v-model="testicals" label="I have testicles"></v-switch>

						<v-card style="width:150px;" class="ma-2">
							<v-card-text>
								<v-layout column class="align-center">
									<v-flex>
										<v-avatar
											@click="selectAvatar=true"
											size="72"
											class="avatar"
										>
											{{ avatar }}
										</v-avatar>
									</v-flex>
									<v-flex class="mt-2">
										<h3>
											{{ name }}
										</h3>
									</v-flex>
								</v-layout>
							</v-card-text>
						</v-card>
						<v-text-field v-model="name" label="name"> </v-text-field>
						<v-btn @click="randomAvatar">Random</v-btn>

						<div v-if="selectAvatar">
							<v-text-field
								v-model="search"
								label="Search Avatar"
								clearable
							></v-text-field>
							<v-select
								:items="categories"
								label="Categories"
								v-model="category"
								clearable
							></v-select>

							<v-layout wrap>
								<v-flex v-for="item in results" :key="item.emoji">
									<v-avatar
										@click="avatar = item.emoji;selectAvatar=false "
										size="72"
									>
										{{ item.emoji }}
									</v-avatar>
								</v-flex>
							</v-layout>
						</div>
					</v-card>
					<v-spacer></v-spacer>
					<v-btn flat @click="step--">Back</v-btn>

					<v-btn color="primary" @click="step = 2">
						Continue
					</v-btn>
				</v-stepper-content>
				<v-stepper-content step="3">
					<v-card class="mb-1">
						<v-checkbox
							v-for="consent in consents"
							v-model="consent.value"
							:label="consent.text"
						></v-checkbox>
					</v-card>
					<v-btn flat @click="step--">Back</v-btn>

					<v-btn color="primary" @click="step = 4">
						I will respect my parters wishes
					</v-btn>
				</v-stepper-content>
				<v-stepper-content step="4">
					<v-card class="mb-5" height="200px">
						START
					</v-card>
					<v-spacer></v-spacer>
					<v-btn flat @click="step--">Back</v-btn>

					<v-btn color="primary" @click="step = 4">
						Let's Do This
					</v-btn>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
	</div>
</template>
<!-- ******************************************************************* -->
<style>
	.Profile {
	}
	.v-list__tile__title,
	.v-list__tile {
		/* font-size: 72px;
		line-height: 84px;
		height: 90px; */
	}
	.Profile .v-avatar {
		/* height: 72px !important; */
		/* width: 72px !important;
		background: black; */
		font-size: 42px;
		cursor: pointer;
	}
	.avatar {
		border: 2px solid black;
		background: #fff;
	}
</style>
